import Vue from 'vue'
import VueBarCodeComponent from 'vue-barcode'

Vue.component('barcode', VueBarCodeComponent)

Vue.use(VueBarCodeComponent)

export default VueBarCodeComponent